import image1 from "../../assets/images/pastor-slide3.jpg";
import image2 from "../../assets/images/church7.jpg";
import image3 from "../../assets/images/pastor-alex.jpg";
import image4 from "../../assets/images/slide-children.jpg";
// import image5 from "../../assets/images/pastor-slide2.jpg";
import image6 from "../../assets/images/pastor-benjamin.jpg";
import image7 from "../../assets/images/conference.jpg";
import image8 from "../../assets/images/pastor-slide.jpg";
import image9 from "../../assets/images/obligation-pastor.jpg";
import image10 from "../../assets/images/soul-pastor.jpg";
import image11 from "../../assets/images/church2.jpg";
import image12 from "../../assets/images/pastordocas.jpg";
import image13 from "../../assets/images/ss1.jpeg";
import image14 from "../../assets/images/pastorinagbaja.jpg";
import image15 from "../../assets/images/alexdocas2.jpg";
import image16 from "../../assets/images/pastor-alex.jpg";
import image18 from "../../assets/images/xc6.jpeg";

export const items = [
  {
    id: "1",
    cart: "Message",
    image: image1,
    title: "The Mountain of Education ",
    names: " Rev. Alex Gyasi MBE",
    utube: "https://www.youtube.com/embed/BWDPWx6DNqM",
  },
  {
    id: "2",
    cart: "Word",
    image: image2,
    title: "What is Sanctification",
    names: "Pastor Alex Gyasi MBE",
    utube: "https://www.youtube.com/embed/JqvJlt-4gQk",
  },
  {
    id: "3",
    cart: "Word",
    image: image3,
    title: "Living By What is Written",
    names: "Pastor Alex Gyasi MBE",
    utube: "https://www.youtube.com/embed/PYbTDJT49nc",
  },
  {
    id: "4",
    cart: "Soul winning series:",
    image: image4,
    title: "Obligation of A Desciple 1",
    names: "Pastor Alex Gyasi MBE",
    utube: "https://www.youtube.com/embed/WBLse_DpKVY",
  },
  {
    id: "5",
    cart: "Soul winning series:",
    image: image4,
    title: "Obligation of A Desciple 2",
    names: "Pastor Alex Gyasi MBE",
    utube: "//www.youtube.com/embed/HeAOov1SU5s",
  },
  {
    id: "6",
    cart: "Soul winning series:",
    image: image6,
    title: " Friendship and Hospitality",
    names: "Pastor Alex Gyasi MBE",
    utube: "https://www.youtube.com/embed/_Z_blghV9uk",
  },
  {
    id: "7",
    cart: "Soul winning series:",
    image: image7,
    title: "Seeds Sown In The Heart",
    names: "Pastor Alex Gyasi MBE",
    utube: "https://www.youtube.com/embed/dlVNheswTYI",
  },
  {
    id: "8",
    cart: "Soul winning series:",
    image: image8,
    title: "The Messenger's Attitude",
    names: "Pastor Alex Gyasi MBE",
    utube: "https://www.youtube.com/embed/zXZylyT1ujU",
  },
  {
    id: "9",
    cart: "Soul winning series:",
    image: image9,
    title: "The Messenger's Message",
    names: "Pastor Alex Gyasi MBE",
    utube: "hhttps://www.youtube.com/embed/zjeQDqbVSD0",
  },
  {
    id: "10",
    cart: "Soul winning series:",
    image: image10,
    title: "The Value Of Winning A soul",
    names: "Pastor Alex Gyasi MBE",
    utube: "https://www.youtube.com/embed/NAg3fUq66-o",
  },
  {
    id: "11",
    image: image11,
    title: "OTobiah In The Temple",
    names: " Pastor Roland Owusu-Mensah",
    utube: "https://www.youtube.com/embed/u4dUa9NXDjk",
  },
  {
    id: "12",
    image: image1,
    title: "The Issue of Self Image",
    names: " Pastor Alex Gyasi MBE",
    utube: "https://www.youtube.com/embed/nLOAwtJiLlE",
  },
  {
    id: "13",
    image: image13,
    title: "Maintain Your Strength",
    names: " Pastor Roland-Mensah",
    utube: "https://www.youtube.com/embed/GJQW8DwJ43Y",
  },
  {
    id: "14",
    image: image14,
    title: "Step Up",
    names: " Pastor Alex Gyasi MBE",
    utube: "https://www.youtube.com/embed/T0pJyQRzU2s",
  },
  {
    id: "15",
    image: image15,
    title: "Relationship With God",
    names: "Pastor Alex Gyasi MBE",
    utube: "https://www.youtube.com/embed/OgfLHU4LWM0",
  },
  {
    id: "16",
    image: image16,
    title: "The Resurrected Jesus",
    names: "Pastor Alex Gyasi MBE",
    utube: "https://www.youtube.com/embed/kqz3rblF4tw",
  },
  {
    id: "17",
    image: image13,
    title: "Be Fruitful",
    names: "Pastor Roland-Mensah",
    utube: "https://www.youtube.com/embed/9nxRS0I0pkI",
  },
  {
    id: "18",
    image: image12,
    title: "Unsung Heroes 1",
    names: "Pastor Dorcas Gyasi",
    utube: "",
  },
  {
    id: "19",
    image: image12,
    title: "Unsung Heroes 2",
    names: "Pastor Dorcas Gyasi",
    utube: "https://www.youtube.com/embed/C86J9ljfuN8",
  },
  {
    id: "20",
    image: image18,
    title: "The Change of the Heart",
    names: "Pastor Alex Gyasi MBE",
    utube: "https://www.youtube.com/embed/oWBEoBjqdrQ",
  },
];
